export default __webpack_public_path__ + "static/media/sandero-colour-12.48576e3a.jpg";